import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * Native-feeling splash screen. Shown briefly on mount then fades out.
 * On iOS, the real launch image comes from LaunchScreen.storyboard.
 * This is the JS-side splash that runs AFTER native launch, to keep brand
 * moment consistent between web and native.
 */
export default function SplashScreen({ minMs = 900, children }) {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), minMs);
    return () => clearTimeout(t);
  }, [minMs]);
  return (
    <>
      {children}
      <AnimatePresence>
        {!done && (
          <motion.div
            data-testid="splash-screen"
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-[#FBFBFD] dark:bg-[#0A2540]"
          >
            <motion.img
              src="/taip-logo.png"
              alt="TAi-P"
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="w-32 h-32 sm:w-40 sm:h-40 object-contain"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
